module.exports = __webpack_public_path__ + "poppins-regular_0-webfont.5133a89cc49d60269a1d.woff";


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/assets/fonts/poppins-regular_0-webfont.woff
// module id = ../../../../../src/assets/fonts/poppins-regular_0-webfont.woff
// module chunks = 2